import { FadeInSection } from '../../../components/ui'

type Metric = { value: string; label: string; sub?: string }

const METRICS: Metric[] = [
  { value: '3 in 10', label: 'Lapsed customers brought back', sub: 'across early test accounts' },
  { value: '< 10 min', label: 'Setup, end to end', sub: 'CSV in, nudges live' },
  { value: '$0', label: 'Cost to start', sub: 'Free plan, no card' },
  { value: '24/7', label: 'Running for you', sub: 'while you focus on work' },
]

export default function ProofBarSection() {
  return (
    <section
      className="px-6 py-20"
      style={{
        backgroundColor: '#FFE8C2',
        borderBottom: '2px solid #111',
      }}
    >
      <div className="max-w-6xl mx-auto">
        <FadeInSection>
          <div
            className="grid grid-cols-2 md:grid-cols-4 gap-px"
            style={{
              backgroundColor: '#111',
              border: '2px solid #111',
            }}
          >
            {METRICS.map((m) => (
              <div
                key={m.label}
                className="flex flex-col justify-center py-10 px-6"
                style={{ backgroundColor: '#FFE8C2' }}
              >
                <div
                  className="font-extrabold"
                  style={{
                    color: '#111',
                    fontSize: 'clamp(2rem, 4vw, 3rem)',
                    lineHeight: 1,
                    letterSpacing: '-0.03em',
                  }}
                >
                  {m.value}
                </div>
                <div className="mt-3 text-sm font-bold" style={{ color: '#111' }}>
                  {m.label}
                </div>
                {m.sub ? (
                  <div className="mt-1 text-xs" style={{ color: '#5a4736' }}>
                    {m.sub}
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        </FadeInSection>
      </div>
    </section>
  )
}
